import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en';
import { ar } from './ar';

export const translations = {
  en,
  ar
} as const;

export type SupportedLanguages = keyof typeof translations;

export const initI18n = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: en },
        ar: { translation: ar },
      },
      fallbackLng: 'en',
      debug: process.env.NODE_ENV === 'development',
      
      interpolation: {
        escapeValue: false,
      },
      
      // Language detection options
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },
    });

  return i18n;
};


export const handleLanguageChange = async () => {
  const newLang = i18n.language === "en" ? "ar" : "en";
  await i18n.changeLanguage(newLang);
};

// Get current language
export const getCurrentLanguage = (): SupportedLanguages => {
  return i18n.language as SupportedLanguages;
};


export default i18n; 